import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const SavedItems = ({ savedItems, onMoveToCart, onRemoveFromSaved }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-UG', {
      style: 'currency',
      currency: 'UGX',
      minimumFractionDigits: 0
    })?.format(price);
  };

  if (savedItems?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-8 text-center">
        <Icon name="Heart" size={48} className="mx-auto text-muted-foreground mb-4" />
        <h3 className="text-lg font-semibold text-foreground mb-2">No Saved Items</h3>
        <p className="text-muted-foreground mb-4">
          Items you save for later will appear here
        </p>
        <Link to="/product-catalog">
          <Button variant="outline">Browse Catalog</Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-4 border-b border-border">
        <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Heart" size={20} />
          Saved for Later ({savedItems?.length})
        </h2>
      </div>
      <div className="p-4 space-y-4">
        {savedItems?.map((item) => (
          <div key={item?.id} className="flex flex-col sm:flex-row gap-4 p-4 border border-border rounded-lg">
            {/* Product Image */}
            <div className="flex-shrink-0">
              <Link to={`/service-details?id=${item?.id}`}>
                <div className="w-16 h-16 rounded-lg overflow-hidden bg-muted">
                  <Image
                    src={item?.image}
                    alt={item?.name}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-200"
                  />
                </div>
              </Link>
            </div>

            {/* Product Details */}
            <div className="flex-1 min-w-0">
              <Link 
                to={`/service-details?id=${item?.id}`}
                className="block hover:text-primary transition-colors"
              >
                <h3 className="font-semibold text-foreground mb-1 line-clamp-2">
                  {item?.name}
                </h3>
              </Link>
              <p className="text-sm text-muted-foreground mb-2">{item?.category}</p>
              <div className="text-lg font-semibold text-foreground">
                {formatPrice(item?.price)}
              </div>
            </div>

            {/* Actions */}
            <div className="flex sm:flex-col gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => onMoveToCart(item?.id)}
                className="flex items-center gap-1"
              >
                <Icon name="ShoppingCart" size={14} />
                <span>Move to Cart</span>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onRemoveFromSaved(item?.id)}
                className="flex items-center gap-1 text-error hover:text-error/80"
              >
                <Icon name="Trash2" size={14} />
                <span>Remove</span>
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedItems;